import { getExploreName } from '../utils/platform';

export const devConfig = {
  sdkKey: 'RBQb91FEQB5UmR4ojZQcRx60FV2xU0Iz4OUj',
  sdkSecret: '6pRqOhp5QNZ5tIa424ZuTOqL73CNfmeoXgZz',
  webEndpoint: 'zoom.us',
  topic: 'Cool Car',
  name: `${getExploreName()}-${Math.floor(Math.random() * 1000)}`,
  password: 'abc1234',
  signature: 'jobsitecare',
  sessionKey: '',
  userIdentity: '',
  // The user role. 1 to specify host or co-host. 0 to specify participant, Participants can join before the host. The session is started when the first user joins. Be sure to use a number type.
  role: 1
};

export const BASE_URL_LOCAL = 'http://localhost:8081';
export const BASE_URL_SERVER = 'https://avserver.jobsitecare.com';
export const BASE_URL_SERVER_NEW = 'https://avauth.jobsitecare.com';
